// ════════════════════════════════════════════════════════════════════
// DESIGN TOKENS — brand palette, surfaces, borders, text, shadows.
// Shared theme object imported across the UI. Extracted verbatim from App.js.
// ════════════════════════════════════════════════════════════════════
export const C = {
  // Primary brand — refined indigo/blue (more premium than google blue)
  blue:"#3b5bdb", blue10:"#edf2ff", blue20:"#dbe4ff", blue5:"#f6f8ff",
  blueDark:"#2845c6",
  // Secondary accent — muted teal for sophistication (use sparingly: section eyebrows, info chips, secondary highlights)
  teal:"#45939b", teal10:"#e8f4f5", teal20:"#c5e3e6", teal5:"#f4fafb",
  tealDark:"#2d6b72",
  // Status colors — softer, more sophisticated
  green:"#0ca678", green10:"#e6fcf5", greenDark:"#087f5b",
  red:"#e03131",   red10:"#fff5f5",  redDark:"#c92a2a",
  yellow:"#f59f00",yellow10:"#fff9db",
  // Surfaces — neutral grays with slight warmth
  bg:"#ffffff",
  bg2:"#fafbfc",       // page bg
  bg3:"#f5f7fa",       // sidebar/secondary surfaces
  bg4:"#f0f3f7",       // tertiary
  // Borders — refined hierarchy
  border:"#e2e6eb",
  border2:"#eef1f4",
  border3:"#f5f7fa",
  // Text hierarchy — proper contrast
  text:"#111827",      // primary
  sub:"#374151",       // secondary
  muted:"#6b7280",     // tertiary
  muted2:"#9ca3af",    // quaternary
  // Shadows — softer, more layered
  s1:"0 1px 2px rgba(17,24,39,.04), 0 1px 3px rgba(17,24,39,.06)",
  s2:"0 2px 4px rgba(17,24,39,.04), 0 4px 8px rgba(17,24,39,.05)",
  s3:"0 4px 8px rgba(17,24,39,.04), 0 8px 16px rgba(17,24,39,.06)",
  s4:"0 12px 24px rgba(17,24,39,.06), 0 24px 48px rgba(17,24,39,.10)",
  sBlue:"0 4px 14px rgba(59,91,219,.18), 0 2px 6px rgba(59,91,219,.10)",
};
